import Marker from './MarkerItem';

export default Marker;
